import {environment} from "@environments/environment";
import {Injectable} from "@angular/core";


@Injectable()
export class HeaderResourcesInjectorService {

    constructor() {
    }

    injectResources(): void {
        /*this.cssInjector.injectCss("../static/common/css/mycerba.css");
        document.getElementsByTagName("head")[0].appendChild(this.getScriptTemplate("../static/common/js/jquery.js"));
        document.getElementsByTagName("head")[0].appendChild(this.getScriptTemplate("../static/common/js/bootstrap-dropdown.js"));
        document.getElementsByTagName("head")[0].appendChild(this.getScriptTemplate("../static/common/js/bootstrap-collapse.js"));
        document.getElementsByTagName("head")[0].appendChild(this.getScriptTemplate("../static/common/js/bootstrap-transition.js"));
         */

    }

    getScriptTemplate(scriptUrl: string): HTMLScriptElement {
        let scriptElement: HTMLScriptElement;
        scriptElement = document.createElement("script");
        scriptElement.src = environment.templateBaseUrl + scriptUrl;
        scriptElement.type = "text/javascript";
        return scriptElement
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/services/header-resources-injector.service.ts